import Clock from "@components/atoms/Clock";

const FlashSale = () => {
  return (
    <>
      <div className="flash-sale d-flex align-self-center justify-content-between rounded-2">
        <img
          src="/assets/images/text-flash-sale.png"
          className="text-flash-sale"
          alt="Flashsale"
        />
        <div>
          <i className="icon icon-clock-outline me-1"></i>
          <span>จบใน</span>
          <Clock />
        </div>
      </div>
    </>
  );
};

export default FlashSale;
